"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountToParts = void 0;
const STARTS_WITH_DIGIT_REGEX = /^\d/;
const formatAmount = ({ forcePlusSign = true, 
// withNoMinorUnitDigits will remove the 'cents' from the output
withNoMinorUnitDigits = false, value, currency = 'EUR', type = Math.sign(value) === 1 ? 'payin' : 'payout', lang, currencyDisplay = 'symbol', }) => {
    const amount = value.toLocaleString(lang, {
        currency,
        currencyDisplay,
        // By default, allow the currency default amount to be used
        minimumFractionDigits: withNoMinorUnitDigits ? 0 : undefined,
        style: 'currency',
    });
    if (forcePlusSign && type === 'payin') {
        return `+${STARTS_WITH_DIGIT_REGEX.test(amount) ? '' : ' '}${amount}`;
    }
    return amount;
};
const formatAmountToParts = ({ currency, forcePlusSign, lang, type, value, }) => {
    const formattedAmount = formatAmount({
        currency,
        forcePlusSign,
        lang,
        type,
        value,
    });
    return formattedAmount.split(formattedAmount.includes('.') ? '.' : ',');
};
exports.formatAmountToParts = formatAmountToParts;
exports.default = formatAmount;
